angular.module('app.directives').component('radioButtonWell', {
  transclude: true,
  controllerAs: 'vm',
  bindings: {
    heading: '@',
    onSelect: '&',
    isSelected: '&',
    alwaysShowTransclude: '<',
    hideCheckbox: '<',
  },
  template: `
    <div class="row">
      <div class="col-sx-12">
        <div class="radio-button-well" ng-class="vm.isSelected() ? 'radio-button-well-selected' : ''">
          <a href="javascript://" ng-click="vm.onSelect()">
            <div class="row" style="display:flex;align-items:center;">
              <div class="col-xs-1" style="width:30px;">
                <i ng-hide="vm.hideCheckbox" class="fa" ng-class="vm.isSelected() ? 'fa-check-circle-o text-success' : 'fa-circle-o'"
                  style="font-size:16px;"></i>
              </div>
              <div class="col-xs-11">
                <b>{{vm.heading}}</b>
                <div ng-if="vm.isSelected() || vm.alwaysShowTransclude">
                  <div ng-transclude></div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    `,
});



// WEBPACK FOOTER //
// ./app/directives/radio-button-well.js